import React, { useContext, useMemo } from 'react';
import { Typography, Paper, CardActionArea } from '@material-ui/core';
import { PerguntaResponse } from 'api/Assessor/duvidas';
import { getFullTime } from 'utils/DateUtils';
import { formatCPFOrCNPJ } from 'utils/cpfCnpjMask';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import useStyle from './style';

export default function ({ perguntas, nome, cpfUsuario }: PerguntaResponse) {
  const classes = useStyle();
  const { conversaAtual, irParaConversa } = useContext(MensagensContext);
  const isPendente = useMemo(() => perguntas.some(pergunta => !pergunta.resposta), [
    perguntas,
  ]);
  const statusClass = useMemo(
    () => (isPendente ? classes.pendente : classes.respondido),
    [isPendente, classes]
  );
  const isActive = useMemo(() => {
    return conversaAtual?.cpfUsuario === cpfUsuario ? classes.ativo : undefined;
  }, [conversaAtual, cpfUsuario, classes]);

  return (
    <Paper
      className={[classes.conversa, statusClass, isActive].join(' ').trim()}
    >
      <CardActionArea
        className={classes.item}
        onClick={() => irParaConversa(cpfUsuario)}
      >
        {/* <Typography className={classes.coopInfo}>0809 - Sul MT</Typography> */}
        <Typography className={classes.fullTime}>
          {getFullTime(new Date(perguntas[0].dataPergunta))}
        </Typography>
        <Typography className={classes.associado}>{nome}</Typography>
        <Typography className={classes.cpf}>
          CPF {formatCPFOrCNPJ(cpfUsuario, true)}
        </Typography>
      </CardActionArea>
    </Paper>
  );
}
